const data =[



  {
      name:"Building Blocks",
      children:[
        {
          name:"Bot",
          display:"Bot",
          children:null,
          node:"BotNode"
        },
      
        {
          name:"Task",
          children:null,
          display:"Task",
          node:"BizNode"
        },

        {
          name:"SubTask",
          children:null,
          display:"SubTask",
          node:"BizNode"
        },
        {
          name:"ThreadBot",
          children:null,
          display:"Parallel Bot",
          node:"BotNode"
        },


        {
          name:"ThreadTask",
          children:null,
          display:"Parallel Task",
          node:"BizNode"
        },
        {
          name:"ThreadSubTask",
          children:null,
          display:"Parallel Sub Task",
          node:"BizNode"
        },
        {
          name:"WaitForThread",
          display:"Wait For Thread",
          children:null,
          node:"RegularNode",
         
        },
        
  
        {
          name:"If",
          display:"If",
          children:null,
          node:"IfNode"
        },
        {
          name:"IfImage",
          display:"If Image",
          children:null,
          node:"IfNode"
        },
        {
          name:"IfDebug",
          display:"If Debug",
          children:null,
          node:"IfNode"
        },
        {
          name:"ExitCurrentIf",
          display:"Exit Current If",
          children:null,
          node:"IfNode"
        },

        {
          name:"LoopWhile",
          display:"Loop While",
          children:null,
          node:"LoopNode",
        },
        {
          name:"LoopWhileImage",
          display:"Loop While Image",
          children:null,
          node:"LoopNode",
        },
        {
          name:"BreakLoop",
          display:"Break Loop",
          children:null,
          node:"LoopNode",
        },

        {
          name:"LoopWhileNotImage",
          display:"Loop Wait Image",
          children:null,
          node:"LoopNode",
        },

        {
          name:"LoopOverArray",
          display:"Loop Over Array",
          children:null,
          node:"LoopNode",
        },
        {
          name:"LoopCount",
          display:"Loop for Count",
          children:null,
          node:"LoopNode",
        },
        {
          name:"LoopOverMap",
          display:"Loop Over Map",
          children:null,
          node:"LoopNode",
        },
        {
          name:"LoopImageMatch",
          display:"Loop Image Match",
          children:null,
          node:"LoopNode",
        },
        {
          name:"LoopTextLocations",
          display:"Loop Text",
          children:null,
          node:"LoopNode",
        },
        {
          name:"ExitIfNoImage",
          display:"Exit No Image",
          children:null,
          node:"IfNode",
        },
        {
          name:"ExitIfImage",
          display:"Exit On Image",
          children:null,
          node:"IfNode",
        },
        {
          name:"ExceptionIf",
          display:"Exception If",
          children:null,
          node:"IfNode",
        },
        {
          name:"ExceptionIfNoImage",
          display:"Exception No Image",
          children:null,
          node:"IfNode",
        },
        {
          name:"ExceptionIfImage",
          display:"Exception On Image",
          children:null,
          node:"IfNode",
        },

        {
          name:"Switch",
          display:"Switch",
          children:null,
          node:"IfNode",
        }

      
      ]
    },
    {
      name:"Gen-AI",
      children:[
        {
          name:"CreateOpenAIModel",
          display:"Create OpenAI Model",
          children:null,
          node:"RegularNode",
        },


        {
          name:"CallOpenAIModel",
          display:"Call OpenAI Model",
          children:null,
          node:"RegularNode",
        },
        
        {
          name:"CallCustomModel",
          display:"Call Custom Model",
          children:null,
          node:"RegularNode",
        },
        
        {
          name:"AssistantAPI",
          display:"Assistant API",
          children:null,
          node:"RegularNode",
        },
        {
          name:"CallGeminiAI",
          display:"Call Gemini AI",
          children:null,
          node:"RegularNode",
        },

        {
          name:"CallCohereAI",
          display:"Call Cohere AI",
          children:null,
          node:"RegularNode",
        },
        {
          name:"CallClaudeAI",
          display:"Call Claude AI",
          children:null,
          node:"RegularNode",
        }
      
      ]
      },      
        {
      name:"Mouse",
      children:[
      {
        name:"MouseMove",
        display:"Move",
        children:null,
        node:"MouseNode",
      },
      {
        name:"MoveTo",
        display:"Move To",
        children:null,
        node:"MouseNode",
      },
      {
        name:"MoveLocation",
        display:"Move To Location",
        children:null,
        node:"MouseNode",
      },
      {
        name:"PositionalClick",
        display:"Positional Click",
        children:null,
        node:"MouseNode",
      },
      {
        name:"MoveImage",
        display:"Move Image",
        children:null,
        node:"MouseNode",
      },
      {
        name:"MouseClick",
        display:"Click",
        children:null,
        node:"MouseNode",
 
      },
      {
        name:"Navigate",
        display:"Navigate",
        children:null,
        node:"MouseNode",
 
      },

      {
        name:"MouseRightClick",
        display:"Right Click",
        children:null,
        node:"MouseNode",
 
      },
      {
        name:"MouseDoubleClick",
        display:"Double-Click",
        children:null,
        node:"MouseNode",
      },
      {
        name:"MouseMoveDoubleClick",
        display:"Move Double-Click",
        children:null,
        node:"MouseNode",
      },
      {
        name:"MouseImageDoubleClick",
        display:"Image Double-Click",
        children:null,
        node:"MouseNode",
      },
      {
        name:"MouseDrag",
        display:"Drag From To",
        children:null,
        node:"MouseNode",
      },
      {
        name:"MouseDragBy",
        display:"Drag Increment",
        children:null,
        node:"MouseNode",
      },
      
      {
        name:"ImageClickAll",
        display:"Image Click All",
        children:null,
        node:"MouseNode",
      },
      {
        name:"ImageClickOne",
        display:"Image Click One",
        children:null,
        node:"MouseNode",
      },
      {
        name:"ClickImage",
        display:"Click Image",
        children:null,
        node:"MouseNode",
      },
      {
        name:"ClickText",
        display:"Click Text",
        children:null,
        node:"MouseNode",
      },
      {
        name:"AssertImage",
        display:"Assert Image",
        children:null,
        node:"MouseNode",
      },
      {
        name:"AssertImageArea",
        display:"Assert Image Area",
        children:null,
        node:"MouseNode",
      },

      {
        name:"GetTextLocation",
        display:"Get Text Location",
        children:null,
        node:"MouseNode",
      },
      {
        name:"TextLocations",
        display:"Text Locations",
        children:null,
        node:"MouseNode",
      },

      {
        name:"ClickImages",
        display:"Click Images",
        children:null,
        node:"MouseNode",
      },
      {
        name:"ParallelImagesSearch",
        display:"Parallel Search",
        children:null,
        node:"RegularNode",
      },


      {
        name:"ClickLocation",
        display:"Click Location",
        children:null,
        node:"MouseNode",
      },

      {
        name:"LookForImage",
        display:"Look For Image",
        children:null,
        node:"RegularNode",
      },

      {
        name:"WaitImage",
        display:"Wait For Image",
        children:null,
        node:"MouseNode",
      },
      {
        name:"WaitImages",
        display:"Wait For Images",
        children:null,
        node:"MouseNode",
      },
      {
        name:"LookForImages",
        display:"Look For Images",
        children:null,
        node:"MouseNode",
      },
      {
        name:"GetUIControl",
        display:"Get UI Control",
        children:null,
        node:"MouseNode",
      },
      {
        name:"GetControls",
        display:"Get Controls",
        children:null,
        node:"MouseNode",
      },
      {
        name:"GetChildControls",
        display:"Get Child Controls",
        children:null,
        node:"MouseNode",
      },
      {
        name:"ParentControl",
        display:"Get Parent Control",
        children:null,
        node:"MouseNode",
      },
      {
        name:"GetControlAttribute",
        display:"Get Control Attribute",
        children:null,
        node:"MouseNode",
      },

      {
        name:"ClickUIControl",
        display:"Click UI Control",
        children:null,
        node:"MouseNode",
      },
      

      {
        name:"OptionalClickImage",
        display:"Optional Click Image",
        children:null,
        node:"MouseNode",
        attributes:{"image":""}
      },

      {
        name:"MouseMoveClick",
        display:"Move Click",
        children:null,
        node:"MouseNode"
      },
      {
        name:"ScrollUp",
        display:"Scroll Up",
        children:null,
        node:"MouseNode"
      },

      {
        name:"ScrollDown",
        display:"Scroll Down",
        children:null,
        node:"MouseNode"
      },
      {
        name:"ScreenDimensions",
        display:"Screen Dimensions",
        children:null,
        node:"MouseNode",
      },
      {
        name:"GetPosition",
        display:"Get Current Position",
        children:null,
        node:"MouseNode",
      }

      


    ]
  },
  {
  name:"Keyboard",
  children:[
    {
      name:"Text",
      children:null,
      node:"KeyNode",
    },
    {
      name:"Type",
      children:null,
      node:"KeyNode",
    },
    {
      name:"Key",
      children:null,
      node:"KeyNode",
    },
    {
      name:"RepeatKey",
      display:"Repeat Key",
      children:null,
      node:"KeyNode",
    },
    {
      name:"KeyInsert",
      display:"Key Insert",
      children:null,
      node:"KeyNode"
    },
    {
      name:"HotKey",
      display:"Hot Key",
      keyArray:[],
      children:null,
      node:"KeyNode"
    },
    {
      name:"ClearKeys",
      display:"Clear Keys",
      children:null,
      node:"RegularNode"
    },
    {
      name:"SelectKeys",
      display:"Select Keys",
      children:null,
      node:"RegularNode"
    },
    {
      name:"SelectAll",
      display:"Select All",
      children:null,
      node:"RegularNode"
    },
    {
      name:"SimpleCopy",
      display:"Simple Copy",
      children:null,
      node:"RegularNode"
    },
    {
      name:"SimplePaste",
      display:"Simple Paste",
      children:null,
      node:"RegularNode"
    },
    {
      name:"TableToClip",
      display:"Table to Clip",
      children:null,
      node:"RegularNode"
    },

    {
      name:"ClipCopy",
      display:"Clip Copy",
      children:null,
      node:"RegularNode"
    },
    {
      name:"ClipPaste",
      display:"Clip Paste",
      children:null,
      node:"RegularNode"
    },
    {
      name:"SetClipboard",
      display:"Set Clipboard",
      children:null,
      node:"RegularNode"
    },
    {
      name:"GetClipboard",
      display:"Get Clipboard",
      children:null,
      node:"RegularNode"
    },
    {
      name:"ScreenScrape",
      display:"Scrape Reference",
      children:null,
      node:"RegularNode"
    },

    {
      name:"ScreenScrapeBetweenReferences",
      display:"Scrape Images",
      children:null,
      node:"RegularNode"
    },

    {
      name:"ScreenScrapeBetweenText",
      display:"Scrape Texts",
      children:null,
      node:"RegularNode"
    },

    {
      name:"ScreenScrapePosition",
      display:"Scrape Position",
      children:null,
      node:"RegularNode"
    }


  ]
  },

  {
    name:"Browser",
    children:[
      {
        name:"BrowserOpen",
        display:"Chrome Open",
        children:null,
        node:"BrowserNode"
      },
      {
        name:"FirefoxOpen",
        display:"Firefox Open",
        children:null,
        node:"BrowserNode"
      },
      {
        name:"MSEdgeOpen",
        display:"MSEdge Open",
        children:null,
        node:"BrowserNode"
      },



      {
        name:"NewTab",
        display:"New Tab",
        children:null,
        node:"BrowserNode"
      },
      {
        name:"PreviousTab",
        display:"Previous Tab",
        children:null,
        node:"BrowserNode"
      },

      {
        name:"NextTab",
        display:"Next Tab",
        children:null,
        node:"BrowserNode"
      },


      {
        name:"BrowserBack",
        display:"Browser Back",
        children:null,
        node:"BrowserNode"
      },

      {
        name:"BrowserForward",
        display:"Browser Forward",
        children:null,
        node:"BrowserNode"
      },

      {
        name:"BrowserRefresh",
        display:"Browser Refresh",
        children:null,
        node:"BrowserNode"
      },

      {
        name:"AddressBar",
        display:"Address Bar",
        children:null,
        node:"BrowserNode"
      },
      {
        name:"CloseTab",
        display:"Close Tab",
        children:null,
        node:"BrowserNode"

      },
      {
        name:"NewWindow",
        display:"New Window",
        children:null,
        node:"BrowserNode"
      },
      
      {
        name:"CloseWindow",
        display:"Close Window",
        children:null,
        node:"BrowserNode"
      },


    ]
  },
  {
    name:"File",
    children:[
      {
        name:"LaunchFile",
        display:"Launch File",
        children:null,
        node:"FileNode"
      },
      {
        name:"ListFiles",
        display:"List Files",
        children:null,
        node:"FileNode"
      },
      {
        name:"ListFolders",
        display:"List Folders",
        children:null,
        node:"FileNode"
      },

        {
          name:"CopyFile",
          display:"Copy File",
          children:null,
          node:"FileNode"
        },
        {
          name:"MoveFile",
          display:"Move File",
          children:null,
          node:"FileNode"
        },
        {
          name:"DeleteFile",
          display:"Delete File",
          children:null,
          node:"FileNode"
        },
        {
          name:"FileName",
          display:"File Name",
          children:null,
          node:"FileNode"
        },
        {
          name:"FileExt",
          display:"File Extension",
          children:null,
          node:"FileNode"
        },

        {
          name:"FileExists",
          display:"File Exists",
          children:null,
          node:"FileNode"
        },
        {
          name:"CreateFolder",
          display:"Create Folder",
          children:null,
          node:"FileNode"
        },

        {
          name:"FolderExists",
          display:"Folder Exists",
          children:null,
          node:"FileNode"
        },
        {
          name:"TimeStamp",
          display:"Time Stamp",
          children:null,
          node:"FileNode"
        },
  
      {
        name:"ReadText",
        display:"Read Text",
        children:null,
        node:"FileNode",
      },
      {
        name:"ReadTextAbsolute",
        display:"Read Text Absolute",
        children:null,
        node:"FileNode",
      },
      {
        name:"ReadLines",
        display:"Read Lines",
        children:null,
        node:"FileNode",
      },
      {
        name:"WriteCSV",
        display:"Write CSV",
        children:null,
        node:"FileNode",
      },
      {
        name:"WriteText",
        display:"Write Text",
        children:null,
        node:"FileNode",
      },
      {
        name:"WriteClipBytes",
        display:"Write Bytes",
        children:null,
        node:"FileNode",
      },

      {
        name:"WriteClipImage",
        display:"Write Clipboard Image",
        children:null,
        node:"FileNode",
      },
      {
        name:"AddClipImage",
        display:"Add Clipboard Image",
        children:null,
        node:"FileNode",
      },

      {
        name:"WordToText",
        display:"Word To Text",
        children:null,
        node:"FileNode"
      },

      {
        name:"WriteWord",
        display:"Write Word",
        children:null,
        node:"FileNode",
      }

    ]
  },
  {
    name:"Excel",
    children:[
      {
        name:"SheetNames",
        display:"Sheet Names",
        children:null,
        node:"FileNode"
      },
      {
        name:"SearchExcelRows",
        display:"Search Excel Rows",
        children:null,
        node:"FileNode"
      },
      {
        name:"FindReplaceExcel",
        display:"Find Replace Text",
        children:null,
        node:"FileNode"
      },

      {
        name:"ReadExcelSheet",
        display:"Read Excel Sheet",
        children:null,
        node:"FileNode"
      },
      {
        name:"ReadCSV",
        display:"Read CSV",
        children:null,
        node:"FileNode"
      },
      {
        name:"AddHeader",
        display:"Add Header",
        children:null,
        node:"FileNode"
      },

      {
        name:"RemoveHeader",
        display:"Remove Header",
        children:null,
        node:"FileNode"
      },

      {
        name:"AppendCSV",
        display:"Append CSV",
        children:null,
        node:"FileNode"
      },
      {
        name:"ReadXLS",
        display:"Read XLS",
        children:null,
        node:"FileNode"
      },
      {
        name:"ReadExcelCell",
        display:"Read Excel Cell",
        children:null,
        node:"FileNode"
      },

      {
        name:"ReadExcelRow",
        display:"Read Excel Row",
        children:null,
        node:"FileNode"
      },
      {
        name:"ReadExcelColumn",
        display:"Read Excel Column",
        children:null,
        node:"FileNode"
      },
      {
        name:"ReadExcelSheetAsMap",
        display:"Read Excel As Map",
        children:null,
        node:"FileNode"
      },
      {
        name:"MergeRows",
        display:"Merge Rows",
        children:null,
        node:"RegularNode"
        
      },

      {
        name:"WriteExcelRow",
        display:"Write Excel Row",
        children:null,
        node:"FileNode"
      },
      {
        name:"WriteExcelColumn",
        display:"Write Excel Column",
        children:null,
        node:"FileNode"
      },
      {
        name:"CreateAddSheet",
        display:"Create Add Sheet",
        children:null,
        node:"FileNode"
      },

      {
        name:"WriteExcelSheet",
        display:"Write Excel Sheet",
        children:null,
        node:"FileNode"
      },
      {
        name:"WriteExcelFromMap",
        display:"Write Excel From Map",
        children:null,
        node:"FileNode"
      },
      {
        name:"WriteExcelCell",
        display:"Write Excel Cell",
        children:null,
        node:"FileNode"
      },

      {
        name:"DeleteExcelColumn",
        display:"Delete Excel Column",
        children:null,
        node:"FileNode"
      },
      {
        name:"DeleteExcelRow",
        display:"Delete Excel Row",
        children:null,
        node:"FileNode"
      },
      {
        name:"DeleteDuplicateRows",
        display:"Delete Duplicate Row",
        children:null,
        node:"FileNode"
      },
      {
        name:"DeleteDupesPartial",
        display:"Delete Dupes Partial",
        children:null,
        node:"FileNode"
      },

      {
        name:"UpdateExcelFromMap",
        display:"Update Excel via Map",
        children:null,
        node:"FileNode"
      },
      {
        name:"AppendExcelRows",
        display:"Append Rows",
        children:null,
        node:"FileNode"
      },
      {
        name:"CSVToExcel",
        display:"CSV To Excel",
        children:null,
        node:"FileNode"
      },

      {
        name:"SplitColumnsToMap",
        display:"Split Cols To Map",
        children:null,
        node:"RegularNode"
      },
      {
        name:"CopyColumns",
        display:"Copy Columns",
        children:null,
        node:"RegularNode"
      },
      {
        name:"InsertColumn",
        display:"Insert Column",
        children:null,
        node:"RegularNode"
      },

      {
        name:"UpdateRows",
        display:"Update Rows",
        children:null,
        node:"RegularNode"
      },
      {
        name:"SelectRows",
        display:"Select Rows",
        children:null,
        node:"RegularNode"
      },

      {
        name:"DeleteRows",
        display:"Delete Rows",
        children:null,
        node:"RegularNode"
      },

      {
        name:"AddSheet",
        display:"Add Sheet",
        children:null,
        node:"FileNode"
      },
      {
        name:"DeleteSheet",
        display:"Delete Sheet",
        children:null,
        node:"FileNode"
      },
      {
        name:"CopySheet",
        display:"Copy Sheet",
        children:null,
        node:"FileNode"
      },


      {
        name:"ActiveSheetName",
        display:"Active Sheet Name",
        children:null,
        node:"FileNode"
      },
      {
        name:"FilterRows",
        display:"Filter Rows",
        children:null,
        node:"FileNode"
      },
      {
        name:"SortScalarAsc",
        display:"Sort Asc",
        children:null,
        node:"RegularNode"

      },
      {
        name:"SortScalarDesc",
        display:"Sort Desc",
        children:null,
        node:"RegularNode"

      },

      {
        name:"SortByDateCol",
        display:"Sort Date Col",
        children:null,
        node:"RegularNode"

      },
      {
        name:"SortByCol",
        display:"Sort By Col",
        children:null,
        node:"RegularNode"

      }





    ]
  },
  {
    name:"PDF",
    children:[

      {
        name:"PDFToText",
        display:"PDF To Text",
        children:null,
        node:"FileNode"
      },
      {
        name:"ExtractPDFTables",
        display:"Extract PDF Tables",
        children:null,
        node:"FileNode"
      },
      {
        name:"PDFTableToCSV",
        display:"PDF Tables to CSV",
        children:null,
        node:"FileNode"
      },
      {
        name:"ImagesFromPDF",
        display:"Extract Images",
        children:null,
        node:"FileNode"
      },

      {
        name:"WritePDF",
        display:"Write PDF",
        children:null,
        node:"FileNode"
      }

    ]
  },


  
  {
    name:"User Interaction",
    children:[
      {
        name:"MessageBox",
        display:"Message Box",
        children:null,
        node:"RegularNode"
        
      },

      {
        name:"PromptMessageBox",
        display:"Prompt Message Box",
        children:null,
        node:"RegularNode"
      },
      {
        name:"Form",
        display:"Form",
        children:null,
        node:"RegularNode"
      },
      {
        name:"Menu",
        display:"Form",
        children:null,
        node:"RegularNode"
      },
      {
        name:"ViewForm",
        display:"View Form",
        children:null,
        node:"RegularNode"
      },
      {
        name:"DebugMessageBox",
        display:"Debug Message Box",
        children:null,
        node:"RegularNode"
        
      }

    ]
    },


  {
        name:"Data Structures",
        children:[
          {
            name:"StringCompare",
            display:"Compare Strings",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"StringReverse",
            display:"Reverse String",
            children:null,
            node:"RegularNode"
            
          },
    
          {
            name:"StringNoCaseCompare",
            display:"Ignore Case Compare",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"StringToLinesArray",
            display:"Split Into Lines ",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"TextToTable",
            display:"Text To Table ",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"Slice",
            display:"Slice",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"SliceText",
            display:"Slice Text",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"StringToArray",
            display:"String Split",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"ArrayToString",
            display:"Array To String",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"CopyTextAfter",
            display:"Copy Text After",
            children:null,
            node:"RegularNode"
          },
      
          {
            name:"ExtractTaggedValues",
            display:"Extract Tagged Values",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ExtractValuesSpecial",
            display:"Extract Values Special",
            children:null,
            node:"RegularNode"
            
          },
    
          {
            name:"Trim",
            display:"Trim String",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"TrimChar",
            display:"Trim Character",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"TrimFloat",
            display:"Trim Float",
            children:null,
            node:"RegularNode"
            
          },
    
    
          {
            name:"StringAdd",
            display:"Add Strings",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"Concatenate",
            display:"Add Many Strings",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"UpperCase",
            display:"Upper Case",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"LowerCase",
            display:"Lower Case",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"ContainsPhrase",
            display:"Contains Phrase",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"ContainsPhrases",
            display:"Contains Phrases",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"ContainsPhrasesICase",
            display:"Contains Ignore Case",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"Occurrences",
            display:"Count Occurrences",
            children:null,
            node:"RegularNode"
            
          },
    
          {
            name:"StartsWith",
            display:"Starts With Phrase",
            children:null,
            node:"RegularNode"
            
          },
    
    
    
          {
            name:"StringReplace",
            display:"Replace String",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ReplaceSpecialTags",
            display:"Replace Special Tags",
            children:null,
            node:"RegularNode"
            
          },
    
          {
            name:"Regex",
            display:"Regex Full",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"RegexExtract",
            display:"Regex Extract",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"RegexSub",
            display:"RegexSub",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"FilterRegex",
            display:"Filter Regex",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"NewArray",
            display:"New Array",
            children:null,
            node:"RegularNode"
            
          },


          {
            name:"InitializeArray",
            display:"Initialize Array",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"BlankArray",
            display:"Blank Array",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"ArrayCopy",
            display:"Copy Array",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ArrayReverse",
            display:"Reverse Array",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ArrayToLines",
            display:"Array To Lines ",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ArrayToSet",
            display:"Array To Set ",
            children:null,
            node:"RegularNode"
            
          },
    
          {
            name:"ArrayAdd",
            display:"Array Add",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ArrayLength",
            display:"Array Length",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ArrayGet",
            display:"Array Get",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ArraySet",
            display:"Array Set",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"GetColumn",
            display:"Get Column",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"ArrayDelete",
            display:"Delete Array Item",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ArrayDeleteColumns",
            display:"Delete Columns",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"ArrayRemove",
            display:"Remove Array Item",
            children:null,
            node:"RegularNode"
            
          },


          {
            name:"SliceArray",
            display:"Slice Array",
            children:null,
            node:"RegularNode"
            
          },


          {
            name:"ArrayTrim",
            display:"Trim Array",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ArrayFilter",
            display:"Array Filter",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"ArrayMatchItems",
            display:"Array Match Items",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"ArrayReplace",
            display:"Array Replace",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"ArrayPhraseSearch",
            display:"Array Search Phrase",
            children:null,
            node:"RegularNode"
            
          },


          {
            name:"ArrayToCSV",
            display:"Array To CSV",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"MergeCSVs",
            display:"Merge CSVs",
            children:null,
            node:"RegularNode"
            
          },


          {
            name:"MergeArrays",
            display:"Merge Arrays",
            children:null,
            node:"RegularNode"
            
          },
    
          {
            name:"CSVToArray",
            display:"CSV To Array",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"NewSet",
            display:"New Set",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"InitializeSet",
            display:"Initialize Set Values",
            children:null,
            node:"RegularNode"
            
          },


          {
            name:"SetAddItem",
            display:"Set Add Item",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"SetDeleteItem",
            display:"Set Delete Item",
            children:null,
            node:"RegularNode"
            
          },
          
          {
            name:"SetEmptyItems",
            display:"Set Empty Items",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"SetToArray",
            display:"Set To Array ",
            children:null,
            node:"RegularNode"
            
          },


          {
            name:"MapToCSV",
            display:"Map To CSV",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"NewMap",
            display:"New Map",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"InitializeMap",
            display:"Initialize Map",
            children:null,
            node:"RegularNode"
            
          },

    
          {
            name:"MapAdd",
            display:"Map Add",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"MapGet",
            display:"Map Get",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"MapGetValues",
            display:"Map Get Values",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"MapSetValues",
            display:"Map Set Values",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"MapSearch",
            display:"Map Search",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"MapDelete",
            display:"Map Delete",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"MapFromArray",
            display:"Map From Array",
            children:null,
            node:"RegularNode"
            
          },
    
          {
            name:"MapKeysToArray",
            display:"Map Keys To Array",
            children:null,
            node:"RegularNode"
            
          },
    
          {
            name:"MapValuesToArray",
            display:"Map Values To Array",
            children:null,
            node:"RegularNode"
            
          },
    
    
          {
            name:"InputMapAdd",
            display:"Input Map Add",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"MergeMaps",
            display:"Merge Maps",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ConvertWestern",
            display:"Convert Western",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"GetNumberRanges",
            display:"Get Number Ranges",
            children:null,
            node:"RegularNode"
    
          },
    
          {
            name:"ConvertLang",
            display:"Convert Lang",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"ConvertToString",
            display:"Convert to String",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ConvertToInteger",
            display:"Convert to Integer",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ScientificToNumber",
            display:"Scientific to Number",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"Round",
            display:"Round Number",
            children:null,
            node:"RegularNode"
            
          },
    
          {
            name:"ConvertToJSON",
            display:"Convert to JSON",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ObjectFromJSON",
            display:"Object from JSON",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"ObjectGet",
            display:"Object Get",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"ObjectLength",
            display:"Object Length",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"GetXMLObject",
            display:"Object from XML",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"GetXMLFromObject",
            display:"XML From Object",
            children:null,
            node:"RegularNode"
            
          },

          {
            name:"GetXMLChild",
            display:"Get XML Child",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"GetXMLChildren",
            display:"Get XML Children",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"GetXMLNamedChild",
            display:"Get XML Named Child",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"GetXMLNode",
            display:"Get XML Node",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"GetXMLTagValue",
            display:"Get XML Tag Value",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"SetXMLTagValue",
            display:"Set XML Tag Value",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"GetXMLAttribute",
            display:"Get XML Attribute",
            children:null,
            node:"RegularNode"
            
          },
          {
            name:"GetXPATH",
            display:"Get XPATH",
            children:null,
            node:"RegularNode"
            
          },
          
          
    
          {
            name:"RandomInt",
            display:"Random number",
            children:null,
            node:"RegularNode"
    
          },
    
          {
            name:"RandomChoice",
            display:"Random choice",
            children:null,
            node:"RegularNode"
    
          }
                      
        ]
  },
  {
    name:"DateTime",
    children:[
      {
        name:"FormatDate",
        display:"Format Date",
        children:null,
        node:"RegularNode"

      },
      {
        name:"TimeNow",
        display:"Time Now",
        children:null,
        node:"RegularNode"

      },

      {
        name:"DateToday",
        display:"Date Today",
        children:null,
        node:"RegularNode"

      },

      {
        name:"DateYesterday",
        display:"Date Yesterday",
        children:null,
        node:"RegularNode"

      },
      {
        name:"DateDifference",
        display:"Date Difference",
        children:null,
        node:"RegularNode"

      },
      {
        name:"DateCompare",
        display:"Date Compare",
        children:null,
        node:"RegularNode"

      },

      {
        name:"AddDays",
        display:"Add Days",
        children:null,
        node:"RegularNode"

      },

      {
        name:"DateBack",
        display:"Date Days Back",
        children:null,
        node:"RegularNode"

      },
      {
        name:"GetMonth",
        display:"Get Month",
        children:null,
        node:"RegularNode"

      },
      {
        name:"GetMonthNumber",
        display:"Get Month Number",
        children:null,
        node:"RegularNode"

      },


      {
        name:"Weekday",
        display:"Week Day",
        children:null,
        node:"RegularNode"

      },
      {
        name:"GetDateRanges",
        display:"Get Date Ranges",
        children:null,
        node:"RegularNode"

      },
      {
        name:"SortDates",
        display:"Sort Dates",
        children:null,
        node:"RegularNode"

      }

              
    ]
  },    



  {
    name:"Processing",
    children:[
      {
        name:"AssignVariable",
        display:"Assign Variable",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"BulkAssignVariables",
        display:"Bulk Assign Variables",
        children:null,
        node:"RegularNode"
        
      },

      {
        name:"AddReference",
        display:"Add Page Reference",
        children:null,
        node:"RegularNode",
      },
      {
        name:"WhichPage",
        display:"Which Page",
        children:null,
        node:"RegularNode",
      },

      {
        name:"ImageLocations",
        display:"Locations of Image",
        children:null,
        node:"RegularNode",
      },
      {
        name:"CheckAttestation",
        display:"Check Attestation",
        children:null,
        node:"RegularNode",
      },
      {
        name:"Retry",
        display:"Retry",
        children:null,
        node:"RegularNode",
      },
      
      {
        name:"ImageCount",
        display:"Count Images",
        children:null,
        node:"RegularNode",
      },
      {
        name:"TrimImage",
        display:"Trim Image",
        children:null,
        node:"RegularNode",
      },
      {
        name:"GetComboItems",
        display:"Get Combo Items",
        children:null,
        node:"RegularNode",
      },
      
      {
        name:"ComboSelect",
        display:"Select Combo Item",
        children:null,
        node:"RegularNode",
      },
      {
        name:"ComboSelectText",
        display:"Select Combo Option",
        children:null,
        node:"RegularNode",
      },
      {
        name:"ControlSelectText",
        display:"Control Select Text",
        children:null,
        node:"RegularNode",
      },
      {
        name:"ComboSelectIndex",
        display:"Select Combo Index",
        children:null,
        node:"RegularNode",
      },
      {
        name:"ComboItems",
        display:"Combo Items",
        children:null,
        node:"RegularNode",
      },

      {
        name:"Expression",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"Log",
        children:null,
        node:"RegularNode",
       
      },
      {
        name:"LocalLog",
        children:null,
        node:"RegularNode",
       
      },
      {
        name:"PrintConsole",
        display:"Print Console",
        children:null,
        node:"RegularNode",
       
      },
      {
        name:"DebugPrintConsole",
        display:"Debug Print Console",
        children:null,
        node:"RegularNode",
       
      },
      {
        name:"DebugDump",
        display:"Debug Dump",
        children:null,
        node:"RegularNode",
       
      },
      {
        name:"RaiseException",
        display:"Raise Exception",
        children:null,
        node:"RegularNode",
       
      },

      {
        name:"HotSpot",
        children:null,
        node:"RegularNode"
      },


      {
        name:"Wait",
        children:null,
        node:"WaitNode"
      },
      {
        name:"WaitRandom",
        children:null,
        node:"WaitNode"
      },
      {
        name:"StartWatch",
        children:null,
        node:"WaitNode"
      },
      {
        name:"ElapsedTime",
        children:null,
        node:"WaitNode"
      },

      {
        name:"StopWatch",
        children:null,
        node:"WaitNode"
      },

      {
        name:"Call",
        children:null,
        node:"CallNode"
      },

      {
        name:"ExitCurrent",
        display:"Exit Task/Bot",
        children:null,
        node:"RegularNode",
      },



      {
        name:"WordsToNumber",
        display:"Words To Number",
        children:null,
        node:"RegularNode"
        
      },



      {
        name:"EvalAmount",
        display:"Evaluate Amount",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"GetType",
        display:"Get Type",
        children:null,
        node:"RegularNode"
        
      },
      
      {
        name:"GetInteger",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"VarExists",
        display:"Variable Exists",
        children:null,
        node:"RegularNode"
        
      },

      {
        name:"IsNone",
        display:"Is None",
        children:null,
        node:"RegularNode"
        
      },

      {
        name:"ComposeURL",
        display:"Compose URL",
        children:null,
        node:"RegularNode"

      },

      {
        name:"ClipArrayOut",
        display:"Clipboard Array",
        children:null,
        node:"RegularNode"
        
      },


    
      {
        name:"ClipMapOut",
        display:"Clip Map Out",
        children:null,
        node:"RegularNode"
        
      },

      {
        name:"PrepareOutput",
        display:"Prepare Output",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"FindOpenApp",
        display:"Find Open App",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"GetActiveApp",
        display:"Get Active App",
        children:null,
        node:"RegularNode"
        
      },

      {
        name:"ActivateApp",
        display:"Activate Application",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"AppProtocol",
        display:"App Protocol",
        children:null,
        node:"RegularNode"
        
      },

      {
        name:"BlockMouseKey",
        display:"Block Mouse Keys",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"UnblockMouseKey",
        display:"Unblock Mouse Keys",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"Comment",
        display:"Comment",
        children:null,
        node:"RegularNode"
        
      }

    ]
  },
  {
    name:"Math",
    children:[
      {
        name:"AddAll",
        children:null,
        node:"RegularNode"
        
      },

      {
        name:"Sum",
        children:null,
        node:"RegularNode"
        
      },

      {
        name:"Average",
        children:null,
        node:"RegularNode"
        
      },

      {
        name:"Difference",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"Division",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"Multiplication",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"Increment",
        children:null,
        node:"RegularNode"
        
      },

    ]
    }, 

  {
    name:"Database",
    children:[
      {
        name:"PostgresConnect",
        display:"Postgres Connect",
        children:null,
        node:"RegularNode"
    },
    {
      name:"PostgresClose",
      display:"Postgres Close",
      children:null,
      node:"RegularNode"
  },
  {
      name:"PostgresQuery",
      display:"Postgres Query",
      children:null,
      node:"RegularNode",
   
    },
    {
      name:"MySQLConnect",
      display:"MySQL Connect",
      children:null,
      node:"RegularNode"
  },
{
    name:"MySQLClose",
    display:"MySQL Close",
    children:null,
    node:"RegularNode"
},
{
    name:"MySQLQuery",
    display:"MySQL Query",
    children:null,
    node:"RegularNode",
 
  },

  {
    name:"SQLServerConnect",
    display:"SQLServer Connect",
    children:null,
    node:"RegularNode"
},
{
  name:"SQLServerQuery",
  display:"SQLServer Query",
  children:null,
  node:"RegularNode",

},
{
  name:"SQLServerClose",
  display:"SQLServer Close",
  children:null,
  node:"RegularNode"
},

  {
    name:"QueryValues",
    display:"Query Values",
    children:null,
    node:"RegularNode",
 
  }
  
  ]
  },


  {
    name:"Media",
    children:[
      {
        name:"AudioPlay",
        children:null,
        node:"RegularNode"
        
    },
    {
      name:"ScreenShot",
      display:"Screen Shot",
      children:null,
      node:"RegularNode",
   
  },
  {
    name:"ScreenSection",
    display:"Screen Section",
    children:null,
    node:"RegularNode"
  
},
{
  name:"ScreenSectionReferences",
  display:"Scrape References",
  children:null,
  node:"RegularNode"

},
{
  name:"ScreenSectionText",
  display:"Scrape Section Text",
  children:null,
  node:"RegularNode"

},

{
    name:"VideoCapture",
    display:"Video Capture",
    children:null,
    node:"RegularNode"
  
  }

    ]
  },
  {
    name:"IDP",
    children:[
      {
        name:"OCR",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"ProcessImage",
        display:"Process Image",
        children:null,
        node:"RegularNode",
      },
      {
        name:"TableExtract",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"ExtractFields",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"GetBarCodes",
        children:null,
        node:"RegularNode"
        
      },
      

      {
        name:"OCRKannada",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"OCRScreenSection",
        display:"OCR Screen Section",
        children:null,
        node:"RegularNode"
      
    },
    {
      name:"OCRSectionReferences",
      display:"OCR References",
      children:null,
      node:"RegularNode"
    
  },
  {
    name:"OCRSectionText",
    display:"OCR Screen Text",
    children:null,
    node:"RegularNode"
  
}
]
  },


  {
    name:"Advanced",
    children:[
      {
        name:"SpeechToText",
        display:"Speech To Text",
        children:null,
        node:"RegularNode",
        classType:'mediaActions.SpeechToTextEvent'
      },
      {
        name:"SoundToText",
        display:"Sound To Text",
        children:null,
        node:"RegularNode",
        classType:'mediaActions.SoundToTextEvent'
      },
      {
        name:"TextToSoundFile",
        display:"Text To Sound File",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"TextToSpeech",
        display:"Text To Speech",
        children:null,
        node:"RegularNode",
        classType:"mediaActions.TextToSpeechEvent"
        
      },
      {
        name:"ConvertAudio",
        display:"Convert audio formats",
        children:null,
        node:"RegularNode"
        
      },
  
      {
        name:"REST",
        children:null,
        node:"RESTNode"
      },
      {
        name:"RESTOAuth1",
        children:null,
        node:"RESTNode"
      },

      {
        name:"BasicAuthHeader",
        children:null,
        node:"RegularNode"
      },
      {
        name:"EncryptAES",
        children:null,
        node:"RegularNode"
      },
      {
        name:"DecryptAES",
        children:null,
        node:"RegularNode"
      },

      {
        name:"Login",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"OKTAToken",
        display:"OKTA Token",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"AzureADToken",
        display:"Azure AD Token",
        children:null,
        node:"RegularNode"
        
      },

      {
        name:"GetLocalPassword",
        children:null,
        node:"RegularNode"
        
      },
      {
        name:"PasswordChange",
        display:"Password Change",
        children:null,
        node:"RegularNode"
        
      },

      {
        name:"FormCopy",
        display:"Form Copy",
        children:null,
        node:"RegularNode"
        
    },
  {
      name:"FormPaste",
      display:"Form Paste",
      children:null,
      node:"RegularNode"
      
    }


    ]
  },
  {
    name:"Email",
    children:[
      {
        name:"SendGMail",
        display:"Send GMail",
        children:null,
        node:"EmailNode"
      },
      {
        name:"SendOutlook",
        display:"Send Outlook",
        children:null,
        node:"EmailNode"
      },
      // {
      //   name:"ReadOutlook",
      //   display:"Read Outlook",
      //   children:null,
      //   node:"EmailNode"
      // },

      {
        name:"SendEmail",
        display:"Send Email",
        children:null,
        node:"EmailNode"
      }

    ]
    },
    {
      name:"SalesForce",
      children:[
        {
          name:"SFConnect",
          display:"SF Connect",
          children:null,
          node:"RegularNode"
        },
        {
          name:"SFDisconnect",
          display:"SF Disconnect",
          children:null,
          node:"RegularNode"
        },
        {
          name:"SFCreate",
          display:"SF Create",
          children:null,
          node:"RegularNode"
        },
        {
          name:"SFUpdate",
          display:"SF Update",
          children:null,
          node:"RegularNode"
        },
        {
          name:"SFRead",
          display:"SF Read",
          children:null,
          node:"RegularNode"
        },
        {
          name:"SFDelete",
          display:"SF Delete",
          children:null,
          node:"RegularNode"
        },
        {
          name:"SFQuery",
          display:"SF Query",
          children:null,
          node:"RegularNode"
        },
        {
          name:"SFAttachFile",
          display:"SF Attach File",
          children:null,
          node:"RegularNode"
        },
        {
          name:"SFDownloadAttachments",
          display:"Download Attachments",
          children:null,
          node:"RegularNode"
        },
        {
          name:"SFDeleteAttachments",
          display:"Delete Attachments",
          children:null,
          node:"RegularNode"
        }

          
      ]
      },
  
      {
        name:"ServiceNow",
        children:[
          {
            name:"SNowConnect",
            display:"SNow Connect",
            children:null,
            node:"RegularNode"
          },
          {
            name:"SNowCreate",
            display:"SNow Create",
            children:null,
            node:"RegularNode"
          },
          {
            name:"SNowUpdate",
            display:"SNow Update",
            children:null,
            node:"RegularNode"
          },
          {
            name:"SNowQuery",
            display:"SNow Query",
            children:null,
            node:"RegularNode"
          },
          {
            name:"SNowRead",
            display:"SNow Read",
            children:null,
            node:"RegularNode"
          },
          {
            name:"SNowDelete",
            display:"SNow Delete",
            children:null,
            node:"RegularNode"
          },
          {
            name:"SNowQuery",
            display:"SNow Query",
            children:null,
            node:"RegularNode"
          },
          {
            name:"SNowAttachFile",
            display:"SNow Attach File",
            children:null,
            node:"RegularNode"
          }
  
    
        ]
        },
    
  
    {
      name:"System",
      children:[
        {
          name:"OpenFileExplorer",
          display:"Open File Explorer",
          children:null,
          node:"FileNode"
        },
        {
          name:"SysCommand",
          display:"Sys Command",
          children:null,
          node:"RegularNode"
        },
  
          {
          name:"RunScript",
          display:"Run Script",
          children:null,
          node:"RegularNode"
        },
  
        {
          name:"CMDWindow",
          display:"CMD Window",
          children:null,
          node:"RegularNode"
        },
        {
          name:"SetEnvironment",
          display:"Set Environment",
          children:null,
          node:"RegularNode"
        },
        {
          name:"ShowDeskTop",
          display:"Show Desktop",
          children:null,
          node:"RegularNode"
        },
    


      ]
      }





  ]


  

  export default data;
  